// extracted by mini-css-extract-plugin
export default {"weekProgress":"Progress_weekProgress_e033c","glowBlock":"Progress_glowBlock_fef4f","glow":"Progress_glow_b9055"};